import { createContext } from "react";
import type { User } from "@hub/api/types";

export interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: User | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
  validateSession: () => Promise<boolean>;
  extendSession: () => Promise<boolean>;
}

export const AuthContext = createContext<AuthContextType | null>(null);
